export const groupProgramBookAnswerOfTarget = (data: any, currentTarget: any): any => {
    const answers: any[] = [];
    if (data?.values) {
        let key = 0;

        data.values?.forEach((section: any, i: number) => {
            section.values?.forEach((domain: any, j: number) => {
                domain.values?.forEach((longTerm: any, k: number) => {
                    longTerm.values?.forEach((shortTerm: any, l: number) => {
                        if (section.title == 'Behavior Reduction') {
                            shortTerm.targets = section.targets;
                        }
                        shortTerm.targets?.forEach((target: any, m: number) => {
                            const optionAnswers: any[] = [];
                            const phaseOptionAnswers: any[] = [];
                            let avrAmount = 0;
                            let keyOption = 0;
                            let keyPhaseOption = 0;

                            target.programTargetOptions.forEach((option: any, m: number) => {
                                const ans = option.answer ? option.answer : 0;

                                const promptOptionAnswers: any[] = [];
                                const keyPromptOption = 0;

                                if (option.promptItem) {
                                    promptOptionAnswers[keyPromptOption] = {
                                        programTargetPrompt: option?.promptItem?.id,
                                        answer: 1,
                                    };
                                }

                                optionAnswers[keyOption] = {
                                    programTargetOption: option.id,
                                    answer: ans,
                                    promptAnswers: promptOptionAnswers,
                                };
                                keyOption++;
                                avrAmount = avrAmount + Number(ans);
                            });

                            if (target.isPhased && target.activePhase) {
                                avrAmount = 0;
                                target.activePhase.programTargetPhaseOptions?.forEach((option: any, m: number) => {
                                    const ans = option.answer ? option.answer : 0;

                                    phaseOptionAnswers[keyPhaseOption] = {
                                        programTargetPhaseOption: option.id,
                                        answer: ans,
                                    };
                                    keyPhaseOption++;
                                    avrAmount = avrAmount + Number(ans);
                                });
                            }

                            const promptAnswers: any[] = [];
                            let keyPrompt = 0;

                            if (target.promptItem && target.type !== 1) {
                                keyPrompt = 0;
                                promptAnswers[keyPrompt] = {
                                    programTargetPrompt: target?.promptItem?.id,
                                    answer: 1,
                                };
                            } else if (target.promptItemSelected) {
                                keyPrompt = 0;
                                const promptItemsSel = target.promptItemSelected.split(',');
                                promptItemsSel?.forEach((val: any, m: number) => {
                                    promptAnswers[keyPrompt] = {
                                        programTargetPrompt: val,
                                        answer: 1,
                                    };
                                    keyPrompt++;
                                });
                            }

                            if (target.isPhased) {
                                avrAmount =
                                    Math.round((Number(avrAmount) / Number(phaseOptionAnswers.length)) * 100) / 100;
                            } else {
                                avrAmount = Math.round((Number(avrAmount) / Number(optionAnswers.length)) * 100) / 100;
                            }
                            if (
                                (section.title == 'Behavior Reduction' && l == 0) ||
                                section.title != 'Behavior Reduction'
                            ) {
                                answers[key] = {
                                    programTarget: target.id,
                                    isSkip: target.isSkip === true ? 1 : target.isSkip === false ? 0 : target.isSkip,
                                    answer:
                                        (optionAnswers.length && target.type == 3) ||
                                        (target.isPhased &&
                                            target.activePhase &&
                                            phaseOptionAnswers &&
                                            target.type == 3)
                                            ? avrAmount
                                            : target.answer
                                            ? target.answer
                                            : 0,
                                    optionAnswers: optionAnswers,
                                    phaseOptionAnswers: target.isPhased && target.activePhase ? phaseOptionAnswers : [],
                                    promptAnswers: promptAnswers,
                                };
                                key++;
                            }
                        });
                    });
                });
            });
        });
    }

    return {
        seance: data.seanceId,
        answers: answers,
    };
};
